export default "__VITE_ASSET__rq0HGBw6__"